var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AudioPlayer"},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audio,"type":"audio/mpeg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }